import { experiences } from "@/mocks/lawfirm";

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="relative lg:max-w-[420px]">
            <div className="overflow-hidden rounded-lg">
              <img
                src="/images/pro1.jpg"
                alt="김평호 변호사"
                title="광주 부장판사출신 변호사 김평호 대표"
                className="w-full h-[480px] md:h-[560px] object-cover object-top"
              />
            </div>
            <img
              src="/images/law_de.webp"
              alt="김평호 변호사 전문분야 등록증서"
              title="대한변호사협회 전문분야 등록증서"
              className="absolute -bottom-6 -right-4 md:right-6 w-32 md:w-40 rounded-lg border-4 border-white object-contain object-top bg-white h-44 md:h-56 shadow-lg"
            />
          </div>

          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
              <i className="ri-user-star-line"></i>
              대표 변호사 소개
            </p>
            <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              광주부장판사·검사출신변호사
              <br />
              <span className="text-accent-600">김평호</span> 대표변호사
            </h2>

            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-scales-2-line"></i> 대한변호사협회 등록 형사법전문변호사
              </span>
            </div>

            <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-700">
              <strong className="font-semibold text-foreground-900">재판의 흐름을 아는 변호사. </strong>
              15년간의 판사, 6년간의 검사 경력을 바탕으로 법원이 어떤 논리를 살피고 어떤 기준으로 판단하는지를 누구보다 정확히 알고 있습니다. 수사부터 재판·집행까지 함께하는 강력한 변호.
            </p>

            <blockquote className="mt-6 rounded-lg border-l-4 border-accent-500 bg-background-100 px-5 py-4 text-sm md:text-base text-foreground-800 font-medium">
              “판사·검사로 쌓은 풍부한 경륜, 이제는 의뢰인을 위한 강력한 변호로 이어갑니다.”
            </blockquote>

            <div className="mt-8">
              <h3 className="text-sm font-semibold text-foreground-900 tracking-wider">PROFESSIONAL EXPERIENCE</h3>
              <div className="mt-4 space-y-0">
                {experiences.map((exp, idx) => (
                  <div key={`${exp.year}-${idx}`} className="flex gap-4">
                    <div className="flex flex-col items-center">
                      <span className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-500 text-white text-xs font-bold shrink-0">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      {idx < experiences.length - 1 && (
                        <span className="w-px flex-1 bg-background-300"></span>
                      )}
                    </div>
                    <div className="pb-6">
                      <p className="text-sm font-semibold text-foreground-900">{exp.title}</p>
                      <p className="text-xs md:text-sm text-foreground-600 mt-1 whitespace-pre-line">{exp.sub}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}